var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex"},[_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('tooltip',{attrs:{"title":_vm.tooltip}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }